module.exports = __webpack_public_path__ + "media/4x3/eu-ee7f4712.svg";